
export default {
  props: {
    title: {
      type: String,
      default: '',
    },

    location: {
      type: Object,
      default() {
        return {
          city: {
            type: String,
            default: null,
          },
          country: {
            type: String,
            default: null,
          },
        }
      },
    },

    content: {
      type: String,
      default: '',
    },

    expiredDate: {
      type: String,
      default: '',
    },

    arrivalDate: {
      type: [String, Number],
      default: '',
    },

    status: {
      type: String,
      default: '',
    },

    comment: {
      type: Object,
      default() {
        return {
          score_avg: {
            type: Number,
            default: 0,
          },
          count: {
            type: Number,
            default: 0,
          },
        }
      },
    },
  },

  computed: {
    full_location() {
      return `${this.location.city}, ${this.location.country}`
    },
  },
}
